import classNames from "classnames";
import { FC } from "react";
import { OrderCargoOrderActiveListItemExecutionStatus } from "../../../../../common/services/order/cargo-order/active-list/order-cargo-order-active-list";

type OrderActiveListingTableStatusProps = {
  status: OrderCargoOrderActiveListItemExecutionStatus;
};

const OrderActiveListingTableStatusComponent: FC<
  OrderActiveListingTableStatusProps
> = (props) => {
  const getClassnameByStatus = (): string => {
    switch (props.status) {
      case OrderCargoOrderActiveListItemExecutionStatus.CANDIDATURE:
        return "candidature";
      case OrderCargoOrderActiveListItemExecutionStatus.IN_PROGRESS:
        return "in_progress";
      case OrderCargoOrderActiveListItemExecutionStatus.PENDING:
        return "pending";
      case OrderCargoOrderActiveListItemExecutionStatus.PLANNED:
        return "planned";
      default:
        return "";
    }
  };

  const statusClassname = getClassnameByStatus();

  const containerClassNames = classNames(
    "order_active_listing_table_status",
    statusClassname,
  );

  return <div className={containerClassNames}></div>;
};

export default OrderActiveListingTableStatusComponent;
